<template>
  <div class="table-container">
    <TableCommon
      title="对应关系配置"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('Correspondence')"
    >
      <template #button>
        <table-button v-if="mode=== 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode=== 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="Correspondence"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #customer="{row}">
          <wly-input
            v-model="row.customer"
            input-type="customer"
            @enter="handleEnter(...arguments, row)"
            @handleSuffixClick="openDialog($event, row)"
          />
        </template>
        <template #l_customer="{row}">
          <el-input v-model="row.l_customer" size="small" />
        </template>
        <template #l_cust_name="{row}">
          <el-input v-model="row.l_cust_name" size="small" />
        </template>

      </vxe-grid>
    </TableCommon>

    <el-dialog v-dialogDrag :visible.sync="showDialog" title="客户选择" width="70%" append-to-body>
      <template v-if="showDialog">
        <client-select ref="dialogSelect" mode="RELATION" />
      </template>
      <div slot="footer">
        <el-button size="small" type="primary" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ClientSelect from '@/components/dialog/ClientSelect.vue'

export default {
  components: { ClientSelect },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      currentRow: null,
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          { title: '新CRM账号', field: 'customer', slots: { default: 'customer' }},
          { title: '新CRM账号名称', field: 'cust_name' },
          { title: '老要货账号', field: 'l_customer', slots: { default: 'l_customer' }},
          { title: '老要货账号名称', field: 'l_cust_name', slots: { default: 'l_cust_name' }}
        ]
      }
    }
  },
  created() {
    if (this.editRows.length) {
      this.gridOptions.data.push(...this.editRows.map(item => {
        return { ...item }
      }))
    }
  },
  methods: {
    addRow() {
      this.gridOptions.data.push({
        customer: '',
        cust_name: '',
        l_customer: '',
        l_cust_name: ''
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          Object.values(item).forEach(value => {
            if (value.trim() === '') {
              throw new Error('请输入完整的信息！')
            }
          })
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    },
    removeRow() {
      const checkedList = this.$refs['Correspondence'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      if (row) {
        // 分流经销商
        this.currentRow = row
        this.currentRow.cust_name = data.customerName
        this.currentRow.customer = data.customerCode
      }
    },
    openDialog(e, row) {
      e.target.blur()
      this.currentRow = row
      this.showDialog = true
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.currentRow.customer = data.customerCode
        this.currentRow.cust_name = data.customerName
      }
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/components/Correspondence.vue